import { applyTooltip, removeTooltip } from "./Tooltip"

export default {
  /* Add Click Event Listener to `el` on mounted as we only
   * care if the object was clicked
   */
  bind(el, binding, vnode) {
    applyTooltip(el, binding, vnode)
  },

  // We use `componentUpdated` here instead of `update`, as the former
  // waits until the containing component and children have finished updating
  componentUpdated(el, bindings, vnode) {
    // Performed in a `$nextTick()` to prevent render update loops
    vnode.context.$nextTick(() => {
      applyTooltip(el, bindings, vnode)
    })
  },

  // Remove Event Listener on destroy.
  unbind(el) {
    removeTooltip(el)
  }
}
